import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { Typography } from '@mui/material'
import { formatVideoDuration } from '../../../utils/utilities'
import { useVideoPlayerStore } from '../../../store/video-player.store'

const VideoProgress = observer( () => {
    const store = useVideoPlayerStore()

    const [progressStyle, setProgressStyle] = useState( "normal" )
    const { duration, currentTime, videoPlayerStatus } = store


    if ( videoPlayerStatus !== 'loading' && !duration )
        return null

    if ( progressStyle === "normal" )
        return (
            <Typography onClick={() => setProgressStyle( "reverse" )} flexShrink={0} className="duration" style={{ fontSize: '12px' }}>
                {`${formatVideoDuration( currentTime || 0 )} / ${formatVideoDuration( duration || 0 )}`}
            </Typography>
        )

    if ( progressStyle === "reverse" )
        return (
            <Typography onClick={() => setProgressStyle( "normal" )} flexShrink={0} className="duration" style={{ fontSize: '12px' }}>
                {`${formatVideoDuration( ( currentTime - duration ) || 0 )} / ${formatVideoDuration( duration || 0 )}`}
            </Typography>
        )
} )

export default VideoProgress
